import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';
import Product from '@/components/Product';
import HowItWorks from '@/components/HowItWorks';
import Benefits from '@/components/Benefits';
import CTA from '@/components/CTA';
import Footer from '@/components/Footer';

const Index = () => {
  useEffect(() => {
    // Smooth scrolling for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        
        const targetId = this.getAttribute('href')?.substring(1);
        if (!targetId) return;
        
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop - 80, // Offset for the fixed header
            behavior: 'smooth'
          });
        }
      });
    });
    
    return () => {
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.removeEventListener('click', () => {});
      });
    };
  }, []);

  // Schema.org structured data for better SEO
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Wamy AI - Claim Intelligence Platform",
    "applicationCategory": "LegalApplication",
    "operatingSystem": "Web",
    "description": "Claim Intelligence Platform with AI Legal Workers - Collect evidence, refine data, score risk, uncover gaps, and empower AI legal workers to craft winning strategies",
    "audience": {
      "@type": "Audience",
      "audienceType": "Legal Professionals"
    },
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "featureList": [
      "AI Legal Workers",
      "Evidence Collection",
      "Risk Scoring",
      "Legal Strategy Development",
      "Claim Intelligence",
      "Legal Automation"
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Claim Intelligence Platform with AI Legal Workers | Wamy AI</title>
        <meta name="description" content="Collect evidence, refine data, score risk, uncover gaps, and empower AI legal workers to craft winning strategies - all in one seamless workspace." />
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
      </Helmet>
      <Navbar />
      <Hero />
      <Product />
      <HowItWorks />
      <Benefits />
      <CTA />
      <Footer />
    </div>
  );
};

export default Index;
